import type { SearchLegPlace } from '@web-platform/shared-universal-types/src/redux/state/appInitial/user/search';

const isLocationCityOrAirport = (location: SearchLegPlace): boolean => {
  if (!location) return false;
  return location.type === 'City' || location.type === 'Airport';
};

const checkIsAnytime = (dateStr: string | undefined | null, isAnytime?: boolean): boolean =>
  dateStr === '' && isAnytime === true;

export { isLocationCityOrAirport, checkIsAnytime };
